import './Itineraries.css';
import React from 'react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { ReactComponent as ChevronRight } from '../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as ChevronLeft } from '../../resources/icons/IconChevronLeftLight.svg';
import FavouriteBtn from '../atoms/FavouriteBtn/FavouriteBtn';
import RouterLink from '../atoms/RouterLink';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { get, injectImageResolution, pathJoin, getMediaHost, getTags, getDictionaryItem, getListingItemURL, generatrURLFromTags, canUseDOM, getPageThemeColors, getColorByTheme } from '../../utils';
import LazyPicture from '../atoms/LazyPicture';
import getListing, { loadCategoryAlgoliaResults, generateSeeMoreTagsFromRules, formatTagsRuleToFiltersOneByOne, isTagsRule } from '../../utils/getListing';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import ScrollAnimation from 'react-animate-on-scroll';

//pesonlization
import { resolveListPersonalization } from '../../utils/resolveListPersonalization';
import { algoliaScoredCondition } from '../../utils/algoliaScoredCondition';
import { usePersonalizedList } from '@uniformdev/personalize-react';
import { useInView } from 'react-intersection-observer';
import CuratorPicks from '../atoms/CuratorPicks/CuratorPicks';
const renderImage = _ref => {
  let {
    image,
    alt,
    className,
    width,
    heigth,
    imageLink,
    mobileWdith = width,
    mobileHeight = heigth,
    analyticsClick
  } = _ref;
  if (!image) return null;
  const imgSrc = injectImageResolution(`${pathJoin([getMediaHost(), image])}`, width, heigth);
  const mobImgSrc = injectImageResolution(`${pathJoin([getMediaHost(), image])}`, mobileWdith, mobileHeight);
  return imageLink && imageLink.length ? /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    className: "c-header__image-link",
    href: imageLink,
    title: alt,
    ariaLabel: alt,
    onClick: () => {
      if (analyticsClick) {
        analyticsClick();
      }
    }
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: className,
    src: mobImgSrc,
    alt: alt
  }))) : /*#__PURE__*/React.createElement("span", {
    className: "c-header__image-link"
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: className,
    src: mobImgSrc,
    alt: alt
  })));
};
const renderCurator = (curators, hostLink, bannerClickAnalytics) => curators && curators.map((value, index) => {
  return /*#__PURE__*/React.createElement(React.Fragment, {
    key: index
  }, renderImage({
    image: value.Image,
    alt: value.Name,
    width: 30,
    heigth: 30,
    className: 'curator__img-item',
    imageLink: value.Url,
    analyticsClick: () => {
      if (bannerClickAnalytics) {
        bannerClickAnalytics();
      }
    }
  }));
});
export const RecommendationItenaryBlock = _ref2 => {
  let {
    item,
    day,
    days,
    callback,
    analytics,
    hostLink
  } = _ref2;
  const itinerary = item;
  const [firstImage, secondImage, thirdImage] = itinerary.images || [];
  const imgSrc = injectImageResolution(`${pathJoin([getMediaHost(), firstImage || secondImage || thirdImage])}`, 340, 243);
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const korean = get(sitecoreContext, 'language') === 'ko';
  const curators = get(itinerary, 'curators.curators');
  const imageAlt = get(itinerary, 'title');
  let dayCount = itinerary.itineraryDaysCount;
  dayCount = dayCount && parseInt(dayCount) < 10 ? '0' + dayCount : dayCount;
  let dayStr = dayCount ? `${dayCount} ${parseInt(dayCount) <= 1 ? day : days}` : '';
  if (korean) {
    dayStr = dayCount ? `${parseInt(dayCount) <= 1 ? day : days} ${dayCount} ` : '';
  }
  const {
    eventsAnalytics,
    params
  } = analytics;
  return /*#__PURE__*/React.createElement("div", {
    className: "col-12 itineraries__item-col",
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "itineraries__item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "itineraries__image-wrap"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    href: getListingItemURL(hostLink, itinerary.urlSlug, itinerary.url),
    openInSameTab: true,
    linksTarget: undefined,
    onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['bannerClickAnalytics'], params), itinerary.englishTitle),
    title: imageAlt
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: "itineraries__image",
    src: imgSrc,
    alt: imageAlt
  })))), /*#__PURE__*/React.createElement("div", {
    className: "itineraries__info"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(CuratorPicks, {
    curators: curators,
    copy: '',
    analytics: {
      eventsAnalytics,
      params,
      name: itinerary.englishTitle
    }
  })), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.15
  }, /*#__PURE__*/React.createElement("div", {
    className: "itineraries__text-sight"
  }, itinerary.category && itinerary.category.join(', '))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.3
  }, /*#__PURE__*/React.createElement("a", {
    className: "itineraries__item-title",
    target: '_self',
    "aria-label": "Itinerary",
    href: getListingItemURL(hostLink, itinerary.urlSlug, itinerary.url),
    onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['titleClickAnalytics'], params), itinerary.englishTitle)
  }, itinerary.title)), /*#__PURE__*/React.createElement("div", {
    className: "itineraries__push-bottom"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.45
  }, /*#__PURE__*/React.createElement("div", {
    className: "itineraries__date-item"
  }, dayStr))), /*#__PURE__*/React.createElement(FavouriteBtn, {
    callback: callback,
    itemId: itinerary && itinerary.objectID,
    classes: 'itineraries__fav-btn',
    analyticsClick: itineraryTitle => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['addToFavAnalytics'], params), `${itineraryTitle}: ${itinerary.englishTitle}`)
  }))));
};
export const ItenaryBlock = _ref3 => {
  let {
    item,
    day,
    days,
    curatorsCopy,
    callback,
    analytics,
    hostLink,
    componentPrimaryColorActive,
    componentPrimaryColor
  } = _ref3;
  const itinerary = item;
  const [firstImage, secondImage, thirdImage] = itinerary.images || [];
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const korean = get(sitecoreContext, 'language') === 'ko';
  const imageCount = Math.min(3, itinerary && itinerary.images ? itinerary.images.length : 0);
  let dayCount = itinerary.itineraryDaysCount;
  const curators = get(itinerary, 'curators.curators');
  const url = get(itinerary, 'url');
  const urlSlug = get(itinerary, 'urlSlug');
  dayCount = dayCount && parseInt(dayCount) < 10 ? '0' + dayCount : dayCount;
  let dayStr = dayCount ? `${dayCount} ${parseInt(dayCount) <= 1 ? day : days}` : '';
  if (korean) {
    dayStr = dayCount ? `${parseInt(dayCount) <= 1 ? day : days} ${dayCount} ` : '';
  }
  const imageAlt = get(itinerary, 'title');
  const {
    bannerClickAnalytics,
    smallBannerClickAnalytics,
    titleClickAnalytics,
    navBubblesAnalytics,
    prevNextNavAnalytics,
    addToFavAnalytics,
    mobileSlidesAnalytics,
    params
  } = analytics;
  return /*#__PURE__*/React.createElement("div", {
    className: "row curator-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12 col-lg-7 curator-header-theme remove-padding-mobile"
  }, /*#__PURE__*/React.createElement("div", {
    className: "curator__header"
  }, /*#__PURE__*/React.createElement("div", {
    className: ['c-header__image', itinerary ? `with-${imageCount}-image` : ''].join(' ')
  }, firstImage && !secondImage && !thirdImage && /*#__PURE__*/React.createElement("div", {
    className: "c-header__image-left"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInLeft",
    animateOnce: true,
    duration: 1
  }, renderImage({
    image: firstImage,
    alt: imageAlt,
    width: 700,
    heigth: 428,
    imageLink: getListingItemURL(hostLink, urlSlug, url),
    mobileWdith: 325,
    mobileHeight: 243,
    analyticsClick: () => tealiumClickFunc(tealiumMergeClickData(bannerClickAnalytics, params), itinerary.englishTitle)
  }))), secondImage && !thirdImage && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "c-header__image-left"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, renderImage({
    image: firstImage,
    alt: imageAlt,
    width: 356,
    heigth: 428,
    imageLink: getListingItemURL(hostLink, urlSlug, url),
    mobileWdith: 161,
    mobileHeight: 243,
    analyticsClick: () => tealiumClickFunc(tealiumMergeClickData(bannerClickAnalytics, params), itinerary.englishTitle)
  }))), /*#__PURE__*/React.createElement("div", {
    className: "c-header__image-right"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.1,
    delay: 100
  }, renderImage({
    image: secondImage,
    alt: imageAlt,
    width: 356,
    heigth: 428,
    imageLink: getListingItemURL(hostLink, urlSlug, url),
    mobileWdith: 161,
    mobileHeight: 243,
    analyticsClick: () => tealiumClickFunc(tealiumMergeClickData(bannerClickAnalytics, params), itinerary.englishTitle)
  })))), thirdImage && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "c-header__image-left"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, renderImage({
    image: firstImage,
    alt: imageAlt,
    width: 372,
    heigth: 426,
    imageLink: getListingItemURL(hostLink, urlSlug, url),
    mobileWdith: 162,
    mobileHeight: 243,
    analyticsClick: () => tealiumClickFunc(tealiumMergeClickData(bannerClickAnalytics, params), itinerary.englishTitle)
  }))), /*#__PURE__*/React.createElement("div", {
    className: "c-header__image-right"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.1,
    delay: 100
  }, renderImage({
    image: secondImage,
    alt: imageAlt,
    width: 358,
    heigth: 214,
    imageLink: getListingItemURL(hostLink, urlSlug, url),
    mobileWdith: 161,
    mobileHeight: 121,
    analyticsClick: () => tealiumClickFunc(tealiumMergeClickData(bannerClickAnalytics, params), itinerary.englishTitle)
  })), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.2,
    delay: 200
  }, renderImage({
    image: thirdImage,
    alt: imageAlt,
    width: 358,
    heigth: 214,
    imageLink: getListingItemURL(hostLink, urlSlug, url),
    mobileWdith: 161,
    mobileHeight: 121,
    analyticsClick: () => tealiumClickFunc(tealiumMergeClickData(bannerClickAnalytics, params), itinerary.englishTitle)
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12 col-lg-4 curator-theme-white remove-padding-mobile"
  }, /*#__PURE__*/React.createElement("div", {
    className: "curator__content"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement("div", {
    className: "curator__author"
  }, curators && curators.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "curator__img-list"
  }, renderCurator(curators, hostLink, () => tealiumClickFunc(tealiumMergeClickData(smallBannerClickAnalytics, params), itinerary.englishTitle))), /*#__PURE__*/React.createElement("div", {
    className: "c-author__name"
  }, curatorsCopy)))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.05
  }, /*#__PURE__*/React.createElement("div", {
    className: "label-small curator__category"
  }, itinerary.category && itinerary.category.join(', '))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.1
  }, /*#__PURE__*/React.createElement("h3", {
    className: "h3 curator__title"
  }, /*#__PURE__*/React.createElement("a", {
    href: getListingItemURL(hostLink, itinerary.urlSlug, itinerary.url),
    onClick: () => tealiumClickFunc(tealiumMergeClickData(titleClickAnalytics, params), itinerary.englishTitle)
  }, itinerary.title))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.15
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-content__text"
  }, itinerary.introText)), /*#__PURE__*/React.createElement("div", {
    className: "curator__footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "days-box"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.2
  }, dayStr)), /*#__PURE__*/React.createElement("div", {
    className: "btn-like"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "btn-like__animation-item animate__fadeInUp",
    animateOnce: true,
    duration: 1.25
  }, /*#__PURE__*/React.createElement(FavouriteBtn, {
    callback: callback,
    itemId: itinerary && itinerary.objectID,
    classes: 'curator__icon',
    componentPrimaryColor: componentPrimaryColor ? componentPrimaryColor : 'var(--main-color)',
    componentPrimaryColorActive: componentPrimaryColorActive ? componentPrimaryColorActive : 'var(--main-color--active)',
    analyticsClick: e => tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), `${e}: ${itinerary.englishTitle}`)
  })))))));
};
const Itineraries = _ref4 => {
  let {
    curatorType,
    fields,
    params,
    route
  } = _ref4;
  const [itineraries, setItineraries] = React.useState([]);
  const contextItemId = get(fields, 'data.contextItem.id');
  let curtorListingPage = '';
  if (contextItemId) {
    curtorListingPage = `?curators.curators.Id=${contextItemId}`;
  }
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const moduleDictionary = get(fields, 'data.moduleDictionary');
  const defaultTitle = getDictionaryItem(moduleDictionary, 'ItinerariesTitle');
  const dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  const searchCount = Number(get(params, 'SearchCount')) || undefined;
  const useCustomListingPage = get(fields, 'data.datasource.useCustomListingPage.jss.value');
  const considerPageLevelTags = get(fields, 'data.datasource.considerPageLevelTags.jss.value');
  const listingPageLink = get(fields, 'data.datasource.listingPageLink.jss.url');
  const overviewButton = get(fields, 'data.overviewButton.title.jss');
  const overviewButtonTitle = get(fields, 'data.overviewButton.title.jss.value');
  const headerTile = get(fields, 'data.datasource.title') || {
    value: defaultTitle
  };
  const linkHref = useCustomListingPage ? listingPageLink : get(fields, 'data.overviewButton.link.jss.value.href');
  const indexName = get(params, 'SearchIndex');
  const contextTags = getTags(get(fields, 'data.contextItem.tags'));
  const itemTags = get(fields, 'data.datasource') ? getTags(get(fields, 'data.datasource.tags')) : contextTags;
  const [results, setResults] = React.useState([]);
  const [validateItems, setValidateItems] = React.useState([]);
  const [seeMoreURLTags, setSeeMoreURLTags] = React.useState('');
  const contextItemTags = get(fields, 'data.contextItem.tags.values') || [];
  const datasourceTags = get(fields, 'data.datasource.tags.values') || [];
  const isPersonalised = get(sitecoreContext, 'isPersonalised');
  const tagsRule = get(fields, 'data.datasource.tagsRule.jss.value');
  const isTagsRuleUsed = isTagsRule(tagsRule);
  const [isVdsite, setIsVdsite] = React.useState(true);
  const [ref, inView] = useInView({
    threshold: 1,
    triggerOnce: true
  });
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const selectedPrimaryActiveColor = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  const variables = BackgroundColorHex ? {
    '--m26-background-color': BackgroundColorHex,
    '--m26-background-active-color': ActiveColorHex,
    '--m26-color': ColorHex
  } : {
    '--m26-background-color': selectedPrimaryColor,
    '--m26-background-active-color': selectedPrimaryActiveColor,
    '--m26-color': getColorByTheme(selectedPrimaryColor)
  };
  const tagsList = considerPageLevelTags ? [...contextItemTags, ...datasourceTags] : [...datasourceTags];
  const currentPageID = get(route, 'itemId', '').split('-').join('');
  const {
    bannerClickAnalytics,
    titleClickAnalytics,
    navBubblesAnalytics,
    prevNextNavAnalytics,
    addToFavAnalytics,
    mobileSlidesAnalytics,
    exploreMoreAnalytics
  } = fields.data;
  const mapDictionary = dictionaryValues.reduce((map, currentValue) => map.set(currentValue.key.jss.value, currentValue.phrase.jss.value), new Map());

  // // Resolve used conditions based on what is selected with the integrated query
  const contextItem = get(fields, 'data.contextItem');
  const intents = get(fields, 'data.datasource.intents');
  const intentsLength = get(intents, 'targetItems.length');

  // Resolve used conditions based on what is selected with the integrated query
  const conditions = resolveListPersonalization(intents, sitecoreContext);

  // Holder for all condition values
  const allValues = [];

  // Iterate all conditions and determine what the current user is tagged with.
  conditions && Array.isArray(conditions) && conditions.forEach(condition => {
    const {
      handler,
      mappings
    } = condition;
    const conditionValues = handler.getValues({
      mappings,
      sitecoreContext
    });
    if (conditionValues) {
      allValues.push(...conditionValues);
    }
  });
  const {
    personalizedList,
    refreshTracking
  } = usePersonalizedList({
    rendering: contextItem,
    route,
    list: itineraries,
    conditions: [algoliaScoredCondition(allValues)]
  });
  React.useEffect(() => {
    setValidateItems(intentsLength && isPersonalised ? personalizedList : itineraries);
  }, [contextItemId, isPersonalised, itineraries]);
  const tagsListForSeeMore = isTagsRuleUsed ? generateSeeMoreTagsFromRules(tagsRule) : tagsList;
  React.useEffect(() => {
    setSeeMoreURLTags(generatrURLFromTags(tagsListForSeeMore));
    if (inView) {
      if (isPersonalised && intentsLength) {
        (async () => {
          const hits = await loadCategoryAlgoliaResults(allValues || [], algoliaSettings, 'type:Itineraries', searchCount, considerPageLevelTags ? [...contextTags, ...itemTags] : itemTags, [contextItemId ? `curators.curators.Id:${contextItemId}` : ''], currentPageID ? `NOT objectID:${currentPageID}` : '', indexName);
          setItineraries(hits);
          refreshTracking();
        })();
      } else {
        let facetFilters = [['type:Itineraries'], [contextItemId ? `curators.curators.Id:${contextItemId}` : '']];
        let results = [];
        let itemFilter = {
          facetFilters: isTagsRuleUsed ? formatTagsRuleToFiltersOneByOne(tagsRule, facetFilters) : [...facetFilters, considerPageLevelTags ? [...contextTags, ...itemTags] : itemTags],
          filters: currentPageID ? `NOT objectID:${currentPageID}` : ''
        };
        if (searchCount) {
          itemFilter.hitsPerPage = searchCount;
        }
        getListing(indexName, itemFilter, algoliaSettings).then(hits => {
          setItineraries(hits && hits.hits);
          results = [...hits.hits];
          if (searchCount && hits && hits.hits.length !== searchCount) {
            let objectIdFilter = ``;
            results.forEach((el, index) => el.objectID ? objectIdFilter += `${index !== 0 ? 'AND' : ''} NOT objectID:${el.objectID} ` : objectIdFilter);
            let itemFilter = {
              facetFilters: [['type:Itineraries']],
              filters: `(${objectIdFilter})`
            };
            if (searchCount) {
              itemFilter.hitsPerPage = searchCount - hits.hits.length;
            }
            getListing(indexName, itemFilter, algoliaSettings).then(extraItineraries => {
              const finalResults = [...results, ...extraItineraries.hits];
              setItineraries(finalResults);
            });
          }
        });
      }
    }
  }, [isPersonalised, inView]);
  const renderItems = () => {
    let itemsToMap = itineraries;
    if (intentsLength && isPersonalised) {
      itemsToMap = personalizedList;
    }
    return itemsToMap.map((itinerary, index) => {
      return /*#__PURE__*/React.createElement(ItenaryBlock, {
        key: index,
        item: itinerary && itinerary.item ? itinerary.item : itinerary,
        day: mapDictionary.get('Day'),
        curatorsCopy: mapDictionary.get('CuratorsPick'),
        days: mapDictionary.get('Days'),
        hostLink: linkHref + curtorListingPage,
        analytics: {
          bannerClickAnalytics,
          titleClickAnalytics,
          navBubblesAnalytics,
          prevNextNavAnalytics,
          addToFavAnalytics,
          exploreMoreAnalytics,
          mobileSlidesAnalytics,
          params
        },
        componentPrimaryColorActive: selectedPrimaryActiveColor,
        componentPrimaryColor: selectedPrimaryColor
      });
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "container m-26-itineraries",
    style: variables,
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: "curator curator curator-featured common-listing-styles"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-0 col-lg-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-11"
  }, headerTile && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: "h2 curator-featured__heading",
    field: headerTile
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, validateItems && validateItems.length > 0 && /*#__PURE__*/React.createElement(CarouselProvider, null, _ref5 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots
    } = _ref5;
    return /*#__PURE__*/React.createElement("div", {
      className: "curator-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row curator-container__row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-sm-0 col-lg-1"
    }), renderCarousel(renderItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 0
          },
          items: 1
        },
        mobileLandscape: {
          breakpoint: {
            max: 767,
            min: 480
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 1
        }
      },
      containerClass: 'col-sm-12 col-lg-11 curator-main-container'
    }, () => tealiumClickFunc(tealiumMergeClickData(mobileSlidesAnalytics, params)))), /*#__PURE__*/React.createElement("div", {
      className: `curator-pagination__btn btn-group--left btn-group-arrows  ${rtl ? 'btn-group-rtl' : ''}`
    }, renderPreviousButton(() => tealiumClickFunc(tealiumMergeClickData(prevNextNavAnalytics, params), "Previous"))), /*#__PURE__*/React.createElement("div", {
      className: `curator-pagination__btn btn-group--right btn-group-arrows  ${rtl ? 'btn-group-rtl' : ''}`
    }, renderNextButton(() => tealiumClickFunc(tealiumMergeClickData(prevNextNavAnalytics, params), "Next"))), /*#__PURE__*/React.createElement("div", {
      className: "curator-pagination__dots"
    }, renderDots(() => tealiumClickFunc(tealiumMergeClickData(navBubblesAnalytics, params)))), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-xl-1"
    }), /*#__PURE__*/React.createElement("div", {
      className: "col-12 col-xl-11"
    }, /*#__PURE__*/React.createElement("div", {
      className: "news__link-row"
    }, linkHref && /*#__PURE__*/React.createElement(RouterLink, {
      openInSameTab: true,
      title: overviewButtonTitle,
      "aria-label": overviewButtonTitle,
      className: "btn btn-primary d-md-none",
      href: linkHref + curtorListingPage,
      onClick: () => {
        tealiumClickFunc(tealiumMergeClickData(exploreMoreAnalytics, params));
      }
    }, /*#__PURE__*/React.createElement(Text, {
      field: overviewButton
    }))))));
  }), /*#__PURE__*/React.createElement("div", {
    className: "row curator-btns d-none d-md-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-11 offset-lg-1"
  }, linkHref && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.5
  }, /*#__PURE__*/React.createElement(RouterLink, {
    "aria-label": overviewButtonTitle,
    openInSameTab: true,
    className: "btn btn-link",
    href: linkHref + curtorListingPage + seeMoreURLTags,
    onClick: () => tealiumClickFunc(tealiumMergeClickData(exploreMoreAnalytics, params))
  }, /*#__PURE__*/React.createElement(Text, {
    className: "btn-link__text",
    tag: "span",
    field: overviewButton
  }), rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
    className: "btn-link__icon btn-link-icon"
  }) : /*#__PURE__*/React.createElement(ChevronRight, {
    className: "btn-link__icon btn-link-icon"
  }))))))))))));
};
const StyledWrapper = _ref6 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref6;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: ` ${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
export const commonStyles = "cw7wkq5";
const ltrStyles = "lsymdy1";
const rtlStyles = "rkeqkji";
export default Itineraries;